<template><component :is="resolvedComponent" /></template>
<script>
import { experiencesBySlug } from '@/content/culture/experiences';
import CultureExperienceDetailView from './CultureExperienceDetailView.vue';
import ExperienceLandingView from './ExperienceLandingView.vue';

export default {
  name: 'CultureExperienceRouteView',
  components: { CultureExperienceDetailView, ExperienceLandingView },
  computed: {
    resolvedComponent() {
      return experiencesBySlug[this.$route.params.tagSlug]
        ? CultureExperienceDetailView
        : ExperienceLandingView;
    },
  },
};
</script>
